<template>
  <translate v-if="taxName === 'city'">
    Excludes city tax (paid on arrival)
  </translate>
  <translate v-else-if="taxName === 'eco'">
    Excludes eco tax (paid on arrival)
  </translate>
  <translate v-else-if="taxName === 'sales'">
    Excludes sales tax (paid on arrival)
  </translate>
  <span v-else>
    {{ taxName }}
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class ArrivalTaxTranslation extends Vue {
  @Prop()
  taxName: string
}

export default toNative(ArrivalTaxTranslation)
</script>
